import React, { useEffect, useState } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { useSelector } from 'react-redux';
import searchIcon from '../../assets/SidebarIcons/icon-search.svg';
import config from '../../config/Constant';
import { getRequest } from '../../helpers/apiHandler';
import CustomAlert from '../CustomAlert';
import CreateUserRateModal from './CreateUserRateModal';
import DeleteUserRateModal from './DeleteUserRateModal';
import UpdateUserRateModal from './UpdateUserRateModal';
import { titleCase } from '../../helpers/helperFunction';
import plusIcon from '../../assets/SidebarIcons/icon-plus.svg';

const UserRates = () => {
  const { access_token } = useSelector((state) => state.auth.user);
  const [loadingData, setLoadingData] = useState(false);
  const [search, setSearch] = useState('');
  const [data, setData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [userRateData, setUserRateData] = useState(null);

  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  const getCreditData = () => {
    setLoadingData(true);
    const data = { headers: { Authorization: access_token.token } };
    getRequest(`/admin/user-rates`, data, (res) => {
      if (res.success) {
        const result = res.data;
        setData(result);
        setSearchData(result);
        generateColumns(result);
      } else {
        setAlertState({
          message: 'There was an issue while fetching user credits',
          show: true,
          variant: 'danger',
        });
      }
      setLoadingData(false);
    });
  };

  const generateColumns = (data) => {
    if (data.length > 0) {
      const keys = Object.keys(data[0]);
      const generatedColumns = keys.map((key) => ({
        name: key === "iso2" ? "Country" : titleCase(key.replace('_', ' ')),
        sortable: true,
        selector: (row) => row[key],
      }));

      generatedColumns.push({
        name: 'Actions',
        minWidth: '250px',
        selector: (row) => (
          <div className="d-flex justify-content-center align-items-center gap-1">
            <Button
              variant="primary"
              style={{ minWidth: 100 }}
              onClick={() => {
                setUserRateData(row);
                setShowUpdateModal(true);
              }}
            >
              Edit
            </Button>
            <Button
              variant="ghost"
              style={{ minWidth: 100 }}
              onClick={() => {
                setUserRateData(row);
                setShowDeleteModal(true);
              }}
            >
              Delete
            </Button>
          </div>
        ),
      });

      setColumns(generatedColumns);
    }
  };

  const onSearch = (evt) => {
    const { value } = evt.target;
    const filteredData = data.filter(
      (item) =>
        item.name.toLowerCase().includes(value.toLowerCase()) ||
        item.email.toLowerCase().includes(value.toLowerCase())
    );

    setSearch(value);
    setSearchData(value ? filteredData : data);
  };

  useEffect(() => {
    getCreditData();
  }, []);

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  return (
    <div className="w-100">
      <div className="page-heading admin-heading">
        <div className="container-left" style={{ marginBottom: "32px"}}>
          <div className="page-title">User Rates</div>
        </div>
        <div className="w-100 d-flex justify-content-between">
          <div className="w-50">
            <InputGroup className="datatable-search search-input">
              <InputGroup.Append className={focus ? 'input-focus' : ''}>
                <InputGroup.Text>
                  <img alt="..." src={searchIcon} />
                </InputGroup.Text>
              </InputGroup.Append>
              <Form.Control
                placeholder="Search..."
                name="search"
                value={search}
                onChange={onSearch}
                className="search-form"
              />
            </InputGroup>
          </div>
          <div>
            <Button onClick={() => setShowModal(true)}>
              <img alt="..." src={plusIcon} className='mr-2' /> Add User Rate
            </Button>
          </div>
        </div>
      </div>
      <CustomAlert
        message={alertState.message}
        show={alertState.show}
        variant={alertState.variant}
        closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
      />
      <DataTable
        columns={columns}
        data={searchData}
        progressPending={loadingData}
        paginationComponentOptions={{
          rowsPerPageText: 'Items per page:',
        }}
        pagination
      />
      <CreateUserRateModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        setAlertState={setAlertState}
        getCreditData={getCreditData}
      />
      <UpdateUserRateModal
        show={showUpdateModal}
        handleClose={() => {
          setShowUpdateModal(false);
          setUserRateData(null);
        }}
        setAlertState={setAlertState}
        getCreditData={getCreditData}
        userRateData={userRateData}
      />
      <DeleteUserRateModal
        userData={userRateData}
        handleClose={() => {
          setUserRateData(null);
          setShowDeleteModal(false);
        }}
        show={showDeleteModal}
        getCreditData={getCreditData}
        setAlertState={setAlertState}
      />
    </div>
  );
};

export default UserRates;
